export default __webpack_public_path__ + "static/pt-4698bf93b0588a461e78084beb52a68b.svg";